module.exports = __webpack_public_path__ + "static/media/fam.be95c215.png";